const FIELD_FAX = 'fax';
const FIELD_UUID = 'uuid';
const FIELD_TYPE = 'type';
const FIELD_NAME = 'name';
const FIELD_PATH = 'path';
const FIELD_DATE = 'date';
const FIELD_ORDER = 'order';
const FIELD_LABEL = 'label';
const FIELD_VALUE = 'value';
const FIELD_STATUS = 'status';
const FIELD_HM_FLAG = 'hmFlag';
const FIELD_PHY_ZIP = 'phyZip';
const FIELD_US_MAIL = 'usMail';
const FIELD_PC_FLAG = 'pcFlag';
const FIELD_MIGRANT = 'migrant';
const FIELD_PHY_CITY = 'phyCity';
const FIELD_ADD_DATE = 'addDate';
const FIELD_DBA_NAME = 'dbaName';
const FIELD_OP_OTHER = 'opOther';
const FIELD_USERNAME = 'username';
const FIELD_PASSWORD = 'password';
const FIELD_PHY_STATE = 'phyState';
const FIELD_OIC_STATE = 'oicState';
const FIELD_IS_EXISTS = 'isExists';
const FIELD_DOCUMENT_UPLOAD = 'file';
const FIELD_TELEPHONE = 'telephone';
const FIELD_DOT_NUMBER = 'dotNumber';
const FIELD_LEGAL_NAME = 'legalName';
const FIELD_PHY_STREET = 'phyStreet';
const FIELD_MCS150DATE = 'mcs150Date';
const FIELD_MAILING_ZIP = 'mailingZip';
const FIELD_PHY_COUNTRY = 'phyCountry';
const FIELD_MAILING_CITY = 'mailingCity';
const FIELD_DRIVER_TOTAL = 'driverTotal';
const FIELD_PRIVATE_ONLY = 'privateOnly';
const FIELD_INDIAN_TRIBE = 'indianTribe';
const FIELD_IS_NEW_STATUS = 'isNewStatus';
const FIELD_VMT_SOURCE_ID = 'vmtSourceId';
const FIELD_MAILING_STATE = 'mailingState';
const FIELD_EMAIL_ADDRESS = 'emailAddress';
const FIELD_MCS150MILEAGE = 'mcs150Mileage';
const FIELD_NBR_POWER_UNIT = 'nbrPowerUnit';
const FIELD_MAILING_STREET = 'mailingStreet';
const FIELD_RECENT_MILEAGE = 'recentMileage';
const FIELD_EXEMPT_FOR_HIRE = 'exemptForHire';
const FIELD_MAILING_COUNTRY = 'mailingCountry';
const FIELD_PRIVATE_PROPERTY = 'privateProperty';
const FIELD_STATE_GOVERNMENT = 'stateGovernment';
const FIELD_LOCAL_GOVERNMENT = 'localGovernment';
const FIELD_CONTACT_TIME_ZONE = 'contactTimeZone';
const FIELD_CARRIER_OPERATION = 'carrierOperation';
const FIELD_FEDERAL_GOVERNMENT = 'federalGovernment';
const FIELD_MCS150MILEAGE_YEAR = 'mcs150MileageYear';
const FIELD_RECENT_MILEAGE_YEAR = 'recentMileageYear';
const FIELD_AUTHORIZED_FOR_HIRE = 'authorizedForHire';
const FIELD_PRIVATE_PASSENGER_BUSINESS = 'privatePassengerBusiness';
const FIELD_PRIVATE_PASSENGER_NONBUSINESS = 'privatePassengerNonbusiness';

export {
  FIELD_FAX,
  FIELD_UUID,
  FIELD_PATH,
  FIELD_TYPE,
  FIELD_NAME,
  FIELD_DATE,
  FIELD_LABEL,
  FIELD_ORDER,
  FIELD_VALUE,
  FIELD_STATUS,
  FIELD_HM_FLAG,
  FIELD_PHY_ZIP,
  FIELD_US_MAIL,
  FIELD_PC_FLAG,
  FIELD_MIGRANT,
  FIELD_USERNAME,
  FIELD_PASSWORD,
  FIELD_PHY_CITY,
  FIELD_ADD_DATE,
  FIELD_DBA_NAME,
  FIELD_OP_OTHER,
  FIELD_PHY_STATE,
  FIELD_OIC_STATE,
  FIELD_IS_EXISTS,
  FIELD_TELEPHONE,
  FIELD_DOT_NUMBER,
  FIELD_LEGAL_NAME,
  FIELD_PHY_STREET,
  FIELD_MCS150DATE,
  FIELD_MAILING_ZIP,
  FIELD_PHY_COUNTRY,
  FIELD_MAILING_CITY,
  FIELD_DRIVER_TOTAL,
  FIELD_PRIVATE_ONLY,
  FIELD_INDIAN_TRIBE,
  FIELD_IS_NEW_STATUS,
  FIELD_VMT_SOURCE_ID,
  FIELD_MAILING_STATE,
  FIELD_EMAIL_ADDRESS,
  FIELD_MCS150MILEAGE,
  FIELD_NBR_POWER_UNIT,
  FIELD_MAILING_STREET,
  FIELD_RECENT_MILEAGE,
  FIELD_EXEMPT_FOR_HIRE,
  FIELD_MAILING_COUNTRY,
  FIELD_DOCUMENT_UPLOAD,
  FIELD_PRIVATE_PROPERTY,
  FIELD_STATE_GOVERNMENT,
  FIELD_LOCAL_GOVERNMENT,
  FIELD_CONTACT_TIME_ZONE,
  FIELD_CARRIER_OPERATION,
  FIELD_FEDERAL_GOVERNMENT,
  FIELD_MCS150MILEAGE_YEAR,
  FIELD_RECENT_MILEAGE_YEAR,
  FIELD_AUTHORIZED_FOR_HIRE,
  FIELD_PRIVATE_PASSENGER_BUSINESS,
  FIELD_PRIVATE_PASSENGER_NONBUSINESS,
};
